import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  static fetch(key) {
    return window.localStorage
      ? window.localStorage[key]
      : undefined;
  }


  static stash(key, val) {
    if (window.localStorage) {
      window.localStorage[key] = val;
    }
  }

  static remove(key) {
    if (window.localStorage) {
      window.localStorage.removeItem(key);
    }
  }
}
